export const CHANGE_PASSWORD_MESSAGES = {
  SUCCESS: "Your password has been changed successfully."
};
